import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useStateValue } from "../context/state/provider";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import LockIcon from "../images/lockIcon.svg";
import sailLogoWhite from "../images/sailLogoWhite.svg";
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { functions } from "../services/firebase/firebase";
import { VIEW } from "../constants/view.constants";
import Loader from "react-loader-spinner";
import axios from "axios";
import querystring from "querystring";
import firebase from "firebase/app";
import { signInWithGoogle, trackUserVisit, db } from "../services/firebase/firebase";
import { FaMicrosoft } from "react-icons/fa";
import { loginRequest } from "../helpers/authConfig";
import { useMsal } from "@azure/msal-react";

const useStyles = makeStyles({
	loginPanel: {
		position: "absolute",
		overflowY: "auto",
		overflowX: "hidden",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		animation: "fadeIn 0.3s ease",
		padding: "20px 16px",
		fontFamily: "var(--font-sans)",
		background: "linear-gradient(180deg, #fafbfc 0%, #fff 40%)",
	},
	paper: {
		marginTop: "0.25rem",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	loadingContainer: {
		marginTop: "100px",
		color: "var(--color-dark-grey)",
		fontSize: "18px",
		animation: "fadeIn 0.3s ease",
	},
	avatar: {
		backgroundColor: "var(--color-alt-grey)",
		color: "var(--active-brand-color)",
		margin: "5px auto",
		width: "36px",
		height: "36px",
	},
	headerIcon: {
		width: "20px",
		height: "20px",
	},
	form: {
		background: "#fff",
		margin: "0 auto",
		padding: "20px 16px",
		width: "min(92%, 360px)",
		borderRadius: "16px",
		border: "1px solid var(--surface-border)",
		boxShadow: "0 10px 28px rgba(15, 23, 42, 0.06)",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	submit: {
		width: "100%",
		height: "42px",
		margin: "16px 0 8px",
		background: "var(--active-msg-bg)",
		color: "#fff",
		fontSize: "calc(var(--active-font-size) - 1px)",
		fontFamily: "var(--font-sans)",
		fontWeight: 600,
		borderRadius: "12px",
		border: "none",
		"&:hover": {
			opacity: "0.92",
			background: "var(--active-msg-bg)",
		},
		"&:focus": {
			outline: "none",
			boxShadow: "0 0 0 3px rgba(11, 79, 156, 0.2)",
		},
	},
	inputs: {
		fontSize: "calc(var(--active-font-size) - 1px)",
		fontFamily: "var(--font-sans)",
		margin: "6px 0",
		width: "100%",
		height: "42px",
		border: "1px solid var(--surface-border)",
		borderRadius: "12px",
		background: "white",
		padding: "12px 14px",
		"&.Mui-focused ": {
			border: "1.5px solid var(--active-brand-color)",
			boxShadow: "0 0 0 3px rgba(11, 79, 156, 0.12)",
		},
	},
	innerInput: {
		WebkitBoxShadow: "0 0 0 1000px white inset",
		padding: "5px",
	},
	inputLabel: {
		color: "var(--color-dark-grey)",
		fontSize: "calc(var(--active-font-size) - 2px)",
		fontWeight: 600,
		fontFamily: "var(--font-sans)",
		textAlign: "start",
		alignSelf: "stretch",
		marginTop: "10px",
		marginBottom: "2px",
	},
	heading: {
		fontWeight: 700,
		letterSpacing: "-0.02em",
		fontFamily: "var(--font-sans)",
		color: "var(--color-dark-grey)",
		fontSize: "calc(var(--active-font-size) + 3px)",
		margin: "8px auto 20px",
	},
	lock: {
		marginRight: "10px",
		height: "16px",
		width: "16px",
	},
	lockDisabled: {
		marginRight: "10px",
		height: "16px",
		width: "16px",
		opacity: "0.5"
	},
	googleBtn: {
		background: "white",
		margin: "10px 0",
		borderColor: "var(--surface-border)",
		color: "var(--color-dark-grey)",
		minWidth: "fit-content",
		width: "100%",
		borderRadius: "12px",
		fontFamily: "var(--font-sans)",
		fontWeight: 600,
		"&:hover": {
			opacity: "0.9",
			background: "white",
		},
	},
	errorMsg: {
		color: "#D8000C",
		fontSize: "12px",
		fontFamily: "var(--font-sans)",
	},
	"@media (max-width: 350px)": {
		form: {
			width: "100%",
		},
	},
});

export default function LoginPanel({ firestore, chatbotId }) {
	// Create a Broadcast Channel with a unique name
	// const broadcastChannelLogin = new BroadcastChannel('clientLoginChannel');
	const classes = useStyles();
	const [{ user }, dispatch] = useStateValue();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(false);
	const [unauthorized, setUnauthorized] = useState(false);
	const [loginLoading, setLoginLoading] = useState(false);
	const { instance, accounts } = useMsal();
	const [loginWithSail, setLoginWithSail] = useState(false);
	const [hasMSLogin, setHasMSLogin] = useState(false);

	useEffect(() => {
		const checkChatbotIdMatch = async () => {
			try {
				const chatbotsMSRef = firestore.collection("chatbotsMSlogin").doc(chatbotId);
				const doc = await chatbotsMSRef.get();
				console.log("Document snapshot:", doc); // Log the document snapshot
				console.log("Document data:", doc.data()); // Log document data (should be undefined if empty)
				if (doc.exists) {
					setHasMSLogin(true); // Match found
				} else {
					setHasMSLogin(false); // No match found
				}
			} catch (error) {
				console.error("Error checking chatbotId:", error);
			}
		};

		checkChatbotIdMatch();
	}, [chatbotId]);

	// Microsoft login
	const handleLogin = async (loginType) => {
		try {
			if (loginType === "redirect") {
				console.log("MS login popup");
				dispatch({
					type: "SET_VIEW",
					view: VIEW.LOGINTMP,
				});
				if (instance.getAllAccounts().length > 0) {
					const response = await instance.acquireTokenSilent({
						...loginRequest,
						account: accounts[0],
					});
					console.log("MS logout response", response)
				}
				const loginResult = await instance.loginRedirect(loginRequest);

				// Track the visit after successful authentication
				// Get user info from loginResult
				const userInfo = loginResult?.account;
				if (userInfo) {
					// Removing trackUserVisit call from here
				}

			}
		} catch (e) {
			console.log(e); // Log the entire error object to understand its structure
			// Use e.errorCode or e.message depending on the structure of your error object
			if (e.errorCode && e.errorCode === 'user_cancelled') {
				console.log("User cancelled the login process.");
				dispatch({
					type: "SET_VIEW",
					view: VIEW.CHATROOM,
				});
				return;
			} else if (e.message && e.message.includes("User cancelled the flow.")) {
				console.log("User cancelled the login process via message.");
				dispatch({
					type: "SET_VIEW",
					view: VIEW.CHATROOM,
				});
				return;
			} else {
				// Handle other errors or rethrow them
				console.error("An unexpected error occurred:", e);
				dispatch({
					type: "SET_VIEW",
					view: VIEW.CHATROOM,
				});
				throw e;
			}
		}
	}

	// Email login
	const handleEmailLogin = async (e) => {
		e.preventDefault();
		setError(false);
		const prevId = user.id;
		const prevUser = firebase.auth().currentUser;
		let userId;
		let userName;
		let key;
		let appKey;

		const _data = {
			UserName: email,
			Password: password,
		};

		try {
			// Get tokens from Ground Floor V2 API
			const res = await axios.post(
				process.env.REACT_APP_GFV2_TOKEN_API,
				querystring.stringify(_data),
				{ headers: { "Content-Type": "application/x-www-form-urlencoded" } }
			);

			let result = res.data;
			if (!result.accessToken) {
				setError(true);
				return;
			}

			setLoginLoading(true);

			// Decode the access token to get user info
			const accessToken = result.accessToken;
			const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));
			const username = tokenPayload.username; // Keep username for permissions API
			const cognitoGroup = tokenPayload['cognito:groups']?.[0] || ''; // Get first group ID

			// Get user permissions from Ground Floor API
			const permissionsRes = await axios.get(
				`${process.env.REACT_APP_GFV2_PERMISSIONS_API}/v3/accounts/permissions/userid/${username}`,
				{
					headers: {
						'Authorization': `Bearer ${accessToken}`,
						'Content-Type': 'application/json',
					}
				}
			);

			// Extract permission keys from the permissions array
			const permissions = permissionsRes.data.data || [];
			const permissionKeys = permissions.map(permission => permission.key);

			// Set user data following original pattern
			const userEmail = email; // Use the email from UI input (like result.Email)
			const userUid = username; // Use username as uid (like result.UserId)
			key = result.Key || "";
			appKey = result.AppKey || cognitoGroup; // appKey is cognito group (like result.AppKey)
			

			// Get Custom Token From Admin SDK with new permission system
			const customTokenRes = await axios({
				method: "post",
				url: `${process.env.REACT_APP_FUNCTIONS_BASE_URL}/app/login`,
				data: { uid: userUid }, // Use userUid as Firebase UID
				headers: {
					'userpermissions': JSON.stringify(permissionKeys),
					'Content-Type': 'application/json',
				}
			});

			let customToken = customTokenRes.data;
			const userCredential = await firebase
				.auth()
				.signInWithCustomToken(customToken);

			// Track the visit after successful authentication
			trackUserVisit(chatbotId, userUid, {
				userName: userEmail,
				userEmail: userEmail
			}).catch(error => {
				console.error('Error tracking user visit:', error);
			});

			console.log("result of login by email signInWithCustomToken", userCredential)
			await firebase
				.auth()
				.currentUser.updateProfile({
					displayName: userEmail,
					email: userEmail,
				});
			console.log("updateProfile")
			userId = userUid;
			userName = userEmail;
			console.log("chatbotId" + chatbotId)
			console.log("userId" + userId)
			
			//Make api call to check flag permission BEFORE Firestore writes
			const resQaAlerts = await axios
				.get(
					`${process.env.REACT_APP_FUNCTIONS_BASE_URL}/app/skills/rooms/${userId}/qaAlerts`,
					{ 
						headers: { 
							'userpermissions': JSON.stringify(permissionKeys),
							'Content-Type': 'application/json'
						} 
					}
				)
			console.log("Success check", resQaAlerts.data)
			console.log("Success check", resQaAlerts.data.data.isAdmin)
			const isAdmin = resQaAlerts.data.data.isAdmin;
			
			const snapShot = await firestore
				.collection("rooms")
				.doc(userId + "***" + chatbotId) //userId
				.get();

			if (!snapShot.exists) {
				
				const firestoreData = {
					pendingMessages: 0,
					chatbotId: chatbotId,
					userEmail: userEmail,
					userEmail_lowercase: userEmail.toLowerCase(),
					email: userEmail,
					email_lowercase: userEmail.toLowerCase(),
					userName: userName,
					userName_lowercase: userName.toLowerCase(),
					userFirstName: userName,
					userFirstName_lowercase: userName.toLowerCase(),
					key: key,
					appKey: appKey,
					userId: userId,
					isAdmin: isAdmin,
					clientKey: appKey, // Add clientKey for contacts API
				};
				
				console.log("DEBUG - FINAL FIRESTORE DATA:", firestoreData);
				console.log("DEBUG - userFirstName in data object:", firestoreData.userFirstName);
				
				await firestore
					.collection("rooms")
					.doc(userId + "***" + chatbotId)
					.set(firestoreData, { merge: true });
			} else {
				//to make sure that a login user will always have a name and email
				//room already exist but re-write userEmail and userName
				const firestoreData = {
					userEmail: userEmail,
					userEmail_lowercase: userEmail.toLowerCase(),
					email: userEmail,
					email_lowercase: userEmail.toLowerCase(),
					userName: userName,
					userName_lowercase: userName.toLowerCase(),
					userFirstName: userName,
					userFirstName_lowercase: userName.toLowerCase(),
					chatbotId: chatbotId,
					key: key,
					appKey: appKey,
					userId: userId,
					isAdmin: isAdmin,
					clientKey: appKey, // Add clientKey for contacts API
				};
				
				await firestore
					.collection("rooms")
					.doc(userId + "***" + chatbotId)
					.set(firestoreData, { merge: true });
			}

			// After successful login
			// Update user status to true (online)
			const currentClientId = chatbotId
			const userRef = db.ref(`rooms/${userId}/clientIds/${currentClientId}`);
			userRef.set(true).catch(error => {
				console.error('Error updating user status:', error);
			});

			await functions.httpsCallable(
				"transferDelete"
			)({
				prevId: prevId,
				userId: userId,
				chatbotId: chatbotId,
				firstName: userName //logged in user firsta name
			});

			//After the login is completed, before to change view
			//delete the previous anonymous user
			console.log("prevId", prevId)
			console.log("prevUser", prevUser)
			if (prevId !== userId) {
				prevUser.delete().then(() => {
					// User deleted.
					console.log("User deleted" + prevId)
				}).catch((error) => {
					// An error ocurred
					console.log("User deleted ERRR: ", error)
				});
			}
			setLoginLoading(false);
			dispatch({
				type: "USER",
				user: {
					...user,
					name: userName,
					id: userId,
					loggedIn: true,
				},
			});
			dispatch({
				type: "SET_VIEW",
				view: VIEW.CHATROOM,
			});

			dispatch({
				type: "ADMIN_SETTINGS",
				admin: {
					adminUser: isAdmin ? true : false,
					feedbackOn: isAdmin ? true : false,
				},
			});
		} catch (err) {
			console.error("Login error:", err);
			if (err?.response?.status === 401 || err?.response?.data?.status === "Unauthorized") {
				setUnauthorized(true);
			} else {
				setError(true);
			}
			setLoginLoading(false);
		}
	};

	// Google login
	//not used anymore
	const handleGoogleLogin = async (e) => {
		e.preventDefault();
		setError(false);
		const prevId = user.id;
		const prevUser = firebase.auth().currentUser;
		let userId;
		let userName;
		let userEmail;
		const auth = await signInWithGoogle(chatbotId);

		//To handle case when user close the popup from google to select user
		if (auth === undefined || auth.message === "The popup has been closed by the user before finalizing the operation.") {
			return
		}
		setLoginLoading(true);
		userId = auth.currentUser.uid;
		userName = auth.currentUser.displayName;
		userEmail = auth.currentUser.email;
		const snapShot = await firestore.collection("rooms").doc(userId).get();

		if (!snapShot.exists) {
			await firestore.collection("rooms").doc(userId).set({
				pendingMessages: 0,
				chatbotId: JSON.parse(sessionStorage.getItem("CLIENT")).chatbotId.replace(/^"(.*)"$/, '$1'),
				// userEmail: userEmail,
				// userName: userName,
				// userFirstName: userName,
				// email: userEmail,

				userEmail: userEmail,
				userEmail_lowercase: userEmail.toLowerCase(),
				email: userEmail,
				email_lowercase: userEmail.toLowerCase(),
				userName: userName,
				userName_lowercase: userName.toLowerCase(),
				userFirstName: userName,
				userFirstName_lowercase: userName.toLowerCase(),
			}, { merge: true });
		} else {
			//to make sure that a login user will always have a name and email
			//room already exist but re-write userEmail and userName
			await firestore.collection("rooms").doc(userId).set({
				// userEmail: userEmail,
				// userName: userName,
				// userFirstName: userName,
				// email: userEmail,

				userEmail: userEmail,
				userEmail_lowercase: userEmail.toLowerCase(),
				email: userEmail,
				email_lowercase: userEmail.toLowerCase(),
				userName: userName,
				userName_lowercase: userName.toLowerCase(),
				userFirstName: userName,
				userFirstName_lowercase: userName.toLowerCase(),

				chatbotId: JSON.parse(sessionStorage.getItem("CLIENT")).chatbotId.replace(/^"(.*)"$/, '$1'),
			}, { merge: true });
		}

		const res = await functions.httpsCallable("transferDelete")({
			prevId: prevId,
			userId: userId,
		});


		prevUser.delete().then(() => {
			// User deleted.
			console.log("User deleted" + prevId)
		}).catch((error) => {
			// An error ocurred
			console.log("User deleted ERRR: ", error)
		});

		setLoginLoading(false);
		dispatch({
			type: "USER",
			user: { ...user, name: userName, id: userId, loggedIn: true },
		});
		dispatch({
			type: "SET_VIEW",
			view: VIEW.CHATROOM,
		});
	};

	return (
		<div className={classes.loginPanel}>
			<div className={classes.paper}>
				{loginLoading ? (
					<div className={classes.loadingContainer}
						role="status"
						aria-label="Loading messages"
					>
						Loading Messages
						<br />
						<br />
						<Loader
							type="Oval"
							color="var(--active-brand-color)"
							height={120}
							width={75}
							aria-hidden="true"
						></Loader>
					</div>
				) : !loginWithSail ? (
					// Display 2 buttons for login
					<form
						className={classes.form}
						onSubmit={(e) => handleEmailLogin(e)}
						validate={"true"}
					>
						<Avatar className={classes.avatar}>
							<LockOutlinedIcon className={classes.headerIcon} />
						</Avatar>
						<h2 className={classes.heading}>Account Login</h2>
						{error && (
							<p className={classes.errorMsg}>
								A login error occurred. Please try again.{" "}
							</p>
						)}
						{unauthorized && (
							<p className={classes.errorMsg}>
								Unauthorized{" "}
							</p>
						)}
						{hasMSLogin &&
							// {/* Microsoft login btn */}
							<Button
								fullWidth
								variant="contained"
								color="primary"
								className={`${classes.submit} ${classes.googleBtn}`}
								onClick={() => handleLogin("redirect")}
							>
								<FaMicrosoft
									color="var(--color-dark-grey)"
									className={classes.lock}
								/>
								Continue with Microsoft{" "}
							</Button>
						}

						{/* Sail login btn */}
						<Button
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							onClick={() => setLoginWithSail(true)}
						>
							<img
								className={classes.lock}
								src={sailLogoWhite}
								alt="lock icon"
							/>
							Continue with Sail{" "}
						</Button>
					</form>
				) : (
					// Display email and password fields
					<form
						className={classes.form}
						onSubmit={(e) => handleEmailLogin(e)}
						validate={"true"}
					>
						<Avatar className={classes.avatar}>
							<LockOutlinedIcon className={classes.headerIcon} />
						</Avatar>
						<h2 className={classes.heading}>Account Login</h2>
						{error && (
							<p className={classes.errorMsg}>
								A login error occurred. Please try again.{" "}
							</p>
						)}
						{unauthorized && (
							<p className={classes.errorMsg}>
								Unauthorized{" "}
							</p>
						)}
						<InputLabel
							className={classes.inputLabel}
							htmlFor="email"
						>
							Email
						</InputLabel>
						<Input
							className={classes.inputs}
							variant="outlined"
							required
							id="email"
							label="Email Address"
							name="email"
							autoComplete="email"
							autoFocus
							value={email}
							inputProps={{
								className: classes.innerInput,
								maxLength: 100,
								type: "email",
							}}
							onChange={(e) => setEmail(e.target.value)}
						/>
						<InputLabel
							className={classes.inputLabel}
							htmlFor="password"
						>
							Password
						</InputLabel>
						<Input
							className={classes.inputs}
							variant="outlined"
							required
							name="password"
							label="Password"
							type="password"
							id="password"
							value={password}
							inputProps={{
								className: classes.innerInput,
								maxLength: 100,
								type: "password",
							}}
							onChange={(e) => setPassword(e.target.value)}
							autoComplete="current-password"
						/>
						<Button
							disabled={email.length === 0 || password.length === 0 ? true : false}
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							onClick={(e) => handleEmailLogin(e)}
						>
							<img
								className={email.length === 0 || password.length === 0 ? classes.lockDisabled : classes.lock}
								src={LockIcon}
								alt="lock icon"
							/>
							Login Securely{" "}
						</Button>
					</form>
				)}
			</div>
		</div>
	);
}
